import { render, staticRenderFns } from "./DuocSpecificationTableInput.vue?vue&type=template&id=7faf6df4&scoped=true"
import script from "./DuocSpecificationTableInput.vue?vue&type=script&lang=js"
export * from "./DuocSpecificationTableInput.vue?vue&type=script&lang=js"
import style0 from "./DuocSpecificationTableInput.vue?vue&type=style&index=0&id=7faf6df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faf6df4",
  null
  
)

export default component.exports